import { apiClient } from "../clientApi";

export interface ApiUsageItem {
  id: number;
  apiKey: string; // key_name from DB
  method: string; // GET / POST / PUT / DELETE
  endpoint: string;
  responseTime: number; // durationMs
  status: number; // status_code
  time: string; // formatted time (HH:MM)
  timestamp: string; // ISO date string
}
export interface ApiUsageStats {
  total_requests: number;
  avg_response_ms: number;
  success_rate: number;
  errors_today: number;
}

export interface ApiUsageResponse {
  page: number;
  items_per_page: number;
  total_records: number;
  total_pages: number;
  data: ApiUsageItem[];
  stats: ApiUsageStats;
}

export const getApiHistory = async (paramsObj: Record<string, any>) => {
  const params = new URLSearchParams();

  Object.entries(paramsObj).forEach(([key, value]) => {
    if (value !== "" && value !== undefined && value !== null) params.append(key, value.toString());
  });

  const { data } = await apiClient.get<ApiUsageResponse>(`/org-apis/history?${params.toString()}`);

  return data;
};
